module.exports = __webpack_public_path__ + "img/ip6.41ebfb59.svg";